import React, { useEffect } from 'react'
import { IBanner } from '@/types/banners'
import { useSpecialOffer } from '@/hooks/utils/useSpecialOffer'
import { useProducts } from '@/hooks/commerce/useProducts'
import { BANNER_STATES } from '@/hooks/banners/useBanner'
import { useRouter } from 'next/navigation'
import { usePurchase } from '@/hooks/commerce/usePurchase'
import { useUser } from '@/hooks/users/useUser'
import { BannerContent } from '../BannerContent'

interface IOfferBannerProps {
  dismissBanner: () => void
  showBanner: () => void
  handleEnableBanner: () => void
  bannerProps: Extract<IBanner, { type: 'offer' }>
  bannerState: string
}

export const OfferBanner: React.FC<IOfferBannerProps> = (props) => {
  const {
    dismissBanner,
    showBanner,
    handleEnableBanner,
    bannerProps,
    bannerState
  } = props
  const router = useRouter()
  const { _id, banner } = bannerProps
  const { isLoggedIn } = useUser()
  const { products } = useProducts({
    params: { getOnly: 'couldLiveWith' }
  })
  const { orders } = usePurchase({
    enabled: isLoggedIn,
    retry: 1,
    retryDelay: 10000,
  })

  const {
    hasSpecialOffer,
  } = useSpecialOffer({
    products,
    orders,
  })

  const handleBannerAction = () => {
    router.push(`/special-offer?offerId=${_id}`)
  }

  const handleCtaClick = (e: React.MouseEvent) => {
    // Prevent the click from bubbling to the strip and pushing twice
    e.stopPropagation()
    handleBannerAction()
  }

  useEffect(() => {
    if (hasSpecialOffer && bannerState !== BANNER_STATES.DISMISSED) {
      handleEnableBanner()
      showBanner()
    }
  }, [hasSpecialOffer, bannerState, showBanner, handleEnableBanner])

  if (!hasSpecialOffer) return null

  return (
    <BannerContent
      text={banner.text}
      image={banner.image}
      cta={banner.cta}
      isClickable
      dismissible={bannerProps.dismissible}
      tone={bannerProps.tone}
      onClick={handleBannerAction}
      onCtaClick={handleCtaClick}
      onDismiss={dismissBanner}
    />
  )
}
